import { useSharedMediaQuery } from './useSharedMediaQuery'

// Everything below the DS `desktop` breakpoint. Separate from `useIsMobile`, which excludes tablets.
const MOBILE_OR_TABLET_MEDIA_QUERY = '(max-width: 1279px)'

export const useIsMobileOrTablet = (): boolean => useSharedMediaQuery(MOBILE_OR_TABLET_MEDIA_QUERY)
